export const HEADING = 'Almost there!';
export const SUB_HEADING = "Let's get you accurate rates";
export const WHY_PG_COPY = 'Why Policygenius?';
export const WHY_PG_SUBCOPY =
  'Our expert agents work for you, not the insurance companies. You can trust them to offer unbiased advice and help you understand all your options.';
export const FREE_QUOTES_COPY = 'Free quotes from top disability insurance carriers';
export const FREE_QUOTES_SUBCOPY =
  'We’re a marketplace — that means we partner with top disability insurance companies to give you multiple quotes, so you can find the policy that’s right for you. Simply fill out the form, and our team of expert advisors will start building a plan tailored to you.';
export const REVIEW_PLAN_COPY = 'Review your plan';
export const REVIEW_PLAN_SUBCOPY =
  'Our team of licensed experts understand disability insurance, and will simplify the process so you feel confident in your decision.';
export const SUBMIT_COPY = 'Submit';
